// Core
import React from "react"
import styled from "styled-components"

// General Components
import BaseContainer from "../../../../components/BaseContainer"

// Assets
import baixeAgoraApp from "../../../../assets/miscellaneous/baixe-agora-app.svg"
import disponivelAppStore from "../../../../assets/miscellaneous/disponivel-na-app-store.svg"
import googlePlayBadge from "../../../../assets/miscellaneous/google-play-badge.svg"

// Styles
import size from "../../../../styles/size"

const Section = styled.section`
  padding: 5rem 0;

  a {
    border: 0;
  }

  img {
    border: 0;
  }

  #img_baixe_agora {
    width: 100%;
    max-width: 245px;
    margin-left: 115px;
    margin-top: 15px;
  }

  #img_play_badge {
    width: 245px;
    margin-left: 120px;
    margin-top: 23px;
  }

  #img_app_store {
    width: 245px;
    margin-left: 20px;
    margin-top: 23px;
  }

  @media (max-width: ${size.laptop}) {
    padding: 5rem 0;

    #img_baixe_agora {
      margin-left: 0;
    }

    #img_play_badge {
      width: 100%;
      max-width: 245px;
      margin-top: 5rem;
      margin-left: 0;
    }

    #img_app_store {
      width: 100%;
      max-width: 245px;
      margin-top: 1rem;
      margin-left: 0;
    }
  }

  @media (max-width: ${size.mobileL}) {
    #img_baixe_agora {
      width: 100%;
      max-width: 425px;
    }

    #img_play_badge {
      width: 100%;
      max-width: 425px;
    }

    #img_app_store {
      width: 100%;
      max-width: 425px;
    }
  }
`

export default function DownloadApps() {
  return (
    <Section>
      <BaseContainer>
        <div>
          <img
            src={baixeAgoraApp}
            id="img_baixe_agora"
            alt="Baixe Agora nosso app"
          />
        </div>

        <div>
          <a
            href="https://play.google.com/store/apps/details?id=com.inpeace.administerioidepsbrasilia&hl=es_CO"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={googlePlayBadge}
              alt="Baixe nosso app na Google Play"
              id="img_play_badge"
            />
          </a>
        </div>

        <div>
          <a
            href="https://apps.apple.com/br/app/ideps/id1490443468"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={disponivelAppStore}
              alt="Baixe nosso app na App Store"
              id="img_app_store"
            />
          </a>
        </div>
      </BaseContainer>
    </Section>
  )
}
